function hasScoreValue(value: unknown) {
  if (value === "" || value === null || value === undefined) return false;
  return Number.isFinite(Number(value));
}

function hasCompleteScore(match: unknown) {
  const item = match && typeof match === "object" ? (match as any) : {};
  return hasScoreValue(item.score1) && hasScoreValue(item.score2);
}

function matchKey(match: unknown) {
  const item = match && typeof match === "object" ? (match as any) : {};
  const id = Number(item.id || 0);
  return Number.isFinite(id) && id > 0 ? String(id) : "";
}

function fallbackKey(roundIndex: number, matchIndex: number) {
  return `pos:${roundIndex}:${matchIndex}`;
}

function scoreOrLocal(apiScore: unknown, localScore: unknown) {
  return hasScoreValue(apiScore) || !hasScoreValue(localScore)
    ? apiScore
    : localScore;
}

export function mergeChallengeRoundsPreservingLocalScores(
  apiRounds: unknown[][],
  localRounds: unknown[][],
) {
  const localByKey = new Map<string, any>();
  (Array.isArray(localRounds) ? localRounds : []).forEach(
    (round, roundIndex) => {
      (Array.isArray(round) ? round : []).forEach((match, matchIndex) => {
        const key = matchKey(match) || fallbackKey(roundIndex, matchIndex);
        if (key) localByKey.set(key, match);
      });
    },
  );

  return (Array.isArray(apiRounds) ? apiRounds : []).map((round, roundIndex) =>
    (Array.isArray(round) ? round : []).map((match, matchIndex) => {
      const key = matchKey(match) || fallbackKey(roundIndex, matchIndex);
      const local = localByKey.get(key);
      if (!local) return match;
      const merged = {
        ...(match && typeof match === "object" ? match : {}),
        score1: scoreOrLocal((match as any)?.score1, local.score1),
        score2: scoreOrLocal((match as any)?.score2, local.score2),
      };
      if (!hasCompleteScore(match) && hasCompleteScore(merged)) {
        return { ...merged, status: "finished" };
      }
      return merged;
    }),
  );
}
